<div class="empty-list">
  <img matListAvatar src="../../assets/empty.png" alt="{{ alt }}" />
  <h3 *ngIf="header">{{ header }}</h3>
  <div style="margin-top: 16px"></div>
  <label style="color: darkgray" *ngIf="label">{{ label }}</label>
</div>
